import type { ReactNode } from 'react'
import { APIProvider } from '@vis.gl/react-google-maps'
import { MapsAppCheckBootstrap } from '@/components/maps/MapsAppCheckBridge'

const MAPS_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined

/**
 * Single shared Maps JS loader for the shell (map + Street View).
 * Nested APIProviders cause loader/App Check races; one provider avoids that.
 */
export function MapsProvider({ children }: { children: ReactNode }) {
  if (!MAPS_KEY) return children

  return (
    <APIProvider apiKey={MAPS_KEY} libraries={['places', 'marker', 'streetView']}>
      <MapsAppCheckBootstrap />
      {children}
    </APIProvider>
  )
}
